import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "canvas-tool" }
const _hoisted_2 = { class: "left-handler" }
const _hoisted_3 = { class: "left-handler-home" }
const _hoisted_4 = { class: "left-handler-home-title" }
const _hoisted_5 = { class: "handler-item group-btn" }
const _hoisted_6 = {
  key: 0,
  class: "right-handler"
}
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { class: "theme-list" }
const _hoisted_10 = { class: "theme-item-content" }
const _hoisted_11 = { class: "colors" }
const _hoisted_12 = { class: "btns" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }

import { ref, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore, useSnapshotStore } from '@/store'
import { getImageDataURL } from '@/utils/image'
import { ShapePoolItem } from '@/configs/shapes'
import { LinePoolItem } from '@/configs/lines'
import useScaleCanvas from '@/hooks/useScaleCanvas'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useCreateElement from '@/hooks/useCreateElement'
import useSlideHandler from '@/hooks/useSlideHandler'
import useScreening from '@/hooks/useScreening'
import { PRESET_THEMES } from '@/configs/theme'
import useSlideTheme from '@/hooks/useSlideTheme'
// import useExport from '@/hooks/useExport'

import ShapePool from './ShapePool.vue'
import LinePool from './LinePool.vue'
import HorizontalItem from './HorizontalItem.vue'
import ChartPool from './ChartPool.vue'
import TableGenerator from './TableGenerator.vue'
import MediaInput from './MediaInput.vue'
import LaTeXEditor from '@/components/LaTeXEditor/index.vue'
import FileInput from '@/components/FileInput.vue'
import LayoutPool from '../Thumbnails/LayoutPool.vue'
import {
  ApiApp,
  AppStore,
  Export,
  TextRotationNone,
  TextRotationDown,
  Market,
  Home,
  Tag
} from '@icon-park/vue-next'
import { Tooltip, Popover, Modal, Menu, Dropdown, message, Button } from 'ant-design-vue'
import emitter, { EmitterEvents, RichTextCommand } from '@/utils/emitter'
import { decrypt, encrypt } from '@/utils/crypto'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {

const MenuItem = Menu.Item
const SubMenu = Menu.SubMenu
const mainStore = useMainStore()
const { creatingElement, editorAreaFocus } = storeToRefs(mainStore)
const { canUndo, canRedo } = storeToRefs(useSnapshotStore())
const { slideIndex, slides } = storeToRefs(useSlidesStore())

const { addHistorySnapshot } = useHistorySnapshot()

const { redo, undo } = useHistorySnapshot()

const { enterScreening, enterScreeningFromStart } = useScreening()
// const { importSpecificFile } = useExport()

const setDialogForExport = mainStore.setDialogForExport

const { createSlideByTemplate, createSlide, copyAndPasteSlide, deleteSlide, sortSlides, updateSlideIndex } = useSlideHandler()

const presetLayoutPopoverVisible = ref(false)

const {
  scaleCanvas,
  setCanvasScalePercentage,
  resetCanvas,
  canvasScalePercentage,
} = useScaleCanvas()

const canvasScalePresetList = [200, 150, 100, 80, 50]
const canvasScaleVisible = ref(false)

const applyCanvasPresetScale = (value: number) => {
  setCanvasScalePercentage(value)
  canvasScaleVisible.value = false
}

const pptTitle = ref('')
const {
  createImageElement,
  createChartElement,
  createTableElement,
  createLatexElement,
  createVideoElement,
  createAudioElement,
} = useCreateElement()

const insertImageElement = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  // 限制图片大小 10M
  const maxLength = 10 * 1024 * 1024
  if (imageFile.size > maxLength) {
    message.error('图片大小不能超过10M')
    return
  }

  getImageDataURL(imageFile).then((dataURL) => createImageElement(dataURL))
}

const {
  applyPresetThemeToSingleSlide,
  applyPresetThemeToAllSlides,
} = useSlideTheme()

const shapePoolVisible = ref(false)
const linePoolVisible = ref(false)
const chartPoolVisible = ref(false)
const tableGeneratorVisible = ref(false)
const mediaInputVisible = ref(false)
const latexEditorVisible = ref(false)
const textTypeSelectVisible = ref(false)

// 绘制文字范围
const drawText = (vertical = false) => {
  mainStore.setCreatingElement({
    type: 'text',
    vertical,
  })
}

// 绘制形状范围
const drawShape = (shape: ShapePoolItem) => {
  mainStore.setCreatingElement({
    type: 'shape',
    data: shape,
  })
  shapePoolVisible.value = false
}

// 绘制线条路径
const drawLine = (line: LinePoolItem) => {
  mainStore.setCreatingElement({
    type: 'line',
    data: line,
  })
  linePoolVisible.value = false
}

const openRemark = () => {
  mainStore.setRemarkState(!mainStore.showRemark)
}

// ppt上移下移
const pageChange = (type: number) => {
  if (type > 0) {
    if (slideIndex.value === slides.value.length - 1) return
    sortSlides(slideIndex.value + type, slideIndex.value)
  }
  else {
    if (slideIndex.value === 0) return
    sortSlides(slideIndex.value + type, slideIndex.value)
  }
  // 添加历史快照
  addHistorySnapshot()
}

// 点击一键生成
const OneGeneration = () => {
  // 清除编辑区选中
  mainStore.setActiveElementIdList([])
  if (editorAreaFocus.value) mainStore.setEditorareaFocus(false)
  window.parent.postMessage({action: 'OneClickGeneration'}, '*')
}
// 点击去首页
const goToHome = () => {
  window.parent.postMessage({action: 'OneClickGoHome'}, '*')
}

// 接收子窗口传递的数据
const receiveMessage = (event: MessageEvent) => { 

  // 验证来源，增加安全性
  // if (event.origin !== 'http://localhost:8081' && event.origin !== window.Glob.VUE_APP_ORIGIN) {
  if (!window.Glob.VUE_APP_ORIGIN.some((o: string) => o === event.origin)) {
    return
  }
  const messageF = event.data
  if (messageF) {
  // 解密数据
    const decryptedMessage = decrypt(messageF)
    const data = JSON.parse(decryptedMessage) 
    if (data.msgType === 'ppttitle') {
      pptTitle.value = data.title
    }   
  }
}
onMounted(() => {
  window.addEventListener('message', receiveMessage)
  
})

onUnmounted(() => {
  window.removeEventListener('message', receiveMessage)
})

const isHorizontal = ref(true)

const handleLayoutWidthChange = (value: number) => {  
  if (value >= 700 && value < 900) {
    isHorizontal.value = false
  }
  else {
    isHorizontal.value = true
  }
}
__expose({
  handleLayoutWidthChange
})

return (_ctx: any,_cache: any) => {
  const _component_IconBack = _resolveComponent("IconBack")!
  const _component_IconNext = _resolveComponent("IconNext")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconPicture = _resolveComponent("IconPicture")!
  const _component_IconGraphicDesign = _resolveComponent("IconGraphicDesign")!
  const _component_IconConnection = _resolveComponent("IconConnection")!
  const _component_IconVideoTwo = _resolveComponent("IconVideoTwo")!
  const _component_IconPpt = _resolveComponent("IconPpt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "主页"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "left-handler-home-action",
              onClick: goToHome
            }, [
              _createVNode(_unref(Home))
            ])
          ]),
          _: 1
        }),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "left-handler-home-line" }, null, -1)),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: pptTitle.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(pptTitle.value), 1)
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "撤销"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconBack, {
            class: _normalizeClass(["handler-item", { disable: !_unref(canUndo) }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(undo)()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "重做"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconNext, {
            class: _normalizeClass(["handler-item", { disable: !_unref(canRedo) }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(redo)()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "插入文字"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IconFontSize, {
              class: _normalizeClass(["icon", { active: _unref(creatingElement)?.type === 'text' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (drawText()))
            }, null, 8, ["class"]),
            _createVNode(_unref(Popover), {
              trigger: "click",
              visible: textTypeSelectVisible.value,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((textTypeSelectVisible).value = $event))
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  class: "text-type-item",
                  onClick: _cache[3] || (_cache[3] = 
                  () => {
                    drawText();
                    textTypeSelectVisible.value = false;
                  }
                )
                }, [
                  _createVNode(_unref(TextRotationNone)),
                  _cache[23] || (_cache[23] = _createTextVNode(" 横向文本框 "))
                ]),
                _createElementVNode("div", {
                  class: "text-type-item",
                  onClick: _cache[4] || (_cache[4] = 
                  () => {
                    drawText(true);
                    textTypeSelectVisible.value = false;
                  }
                )
                }, [
                  _createVNode(_unref(TextRotationDown)),
                  _cache[24] || (_cache[24] = _createTextVNode(" 竖向文本框 "))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_IconDown, { class: "arrow" })
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ]),
        _: 1
      }),
      _createVNode(FileInput, {
        onChange: _cache[6] || (_cache[6] = (files) => insertImageElement(files))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入图片"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconPicture, {
                class: "handler-item",
                style: {"width":"16px"}
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: shapePoolVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((shapePoolVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(ShapePool, {
            onSelect: _cache[7] || (_cache[7] = (shape) => drawShape(shape))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入形状"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconGraphicDesign, {
                class: _normalizeClass(["handler-item", { active: _unref(creatingElement)?.type === 'shape' }])
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: linePoolVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((linePoolVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(LinePool, {
            onSelect: _cache[9] || (_cache[9] = (line) => drawLine(line))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入线条"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconConnection, {
                class: _normalizeClass(["handler-item", { active: _unref(creatingElement)?.type === 'line' }])
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: mediaInputVisible.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((mediaInputVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(MediaInput, {
            onClose: _cache[11] || (_cache[11] = ($event: any) => (mediaInputVisible.value = false)),
            onInsertVideo: _cache[12] || (_cache[12] = 
              (src) => {
                _unref(createVideoElement)(src);
                mediaInputVisible.value = false;
              }
            ),
            onInsertAudio: _cache[13] || (_cache[13] = 
              (src) => {
                _unref(createAudioElement)(src);
                mediaInputVisible.value = false;
              }
            )
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入音视频"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconVideoTwo, { class: "handler-item" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "div-line" }, null, -1)),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "演讲备注"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (openRemark())),
            style: {"cursor":"pointer"}
          }, [
            _createVNode(_unref(Tag))
          ])
        ]),
        _: 1
      })
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "add-element-handler" }, null, -1)),
    (isHorizontal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "一键生成"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", { onClick: OneGeneration }, [
                _createVNode(_unref(Market)),
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text showOrHideSpan" }, "一键生成", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
            overlay: _withCtx(() => [
              _createVNode(_unref(Menu), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(enterScreeningFromStart)()))
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("从头开始")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(enterScreening)()))
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createTextVNode("从当前页开始")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(Tooltip), {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "演示"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_IconPpt),
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text showOrHideSpan" }, "演示", -1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
            overlay: _withCtx(() => [
              _createVNode(_unref(Menu), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_THEMES), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "theme-item",
                        key: index,
                        style: _normalizeStyle({
                  backgroundColor: item.background,
                  fontFamily: item.fontname,
                })
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", {
                            class: "text",
                            style: _normalizeStyle({ color: item.fontColor })
                          }, "文字 Aa", 4),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.colors, (color, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "color-block",
                                key: index,
                                style: _normalizeStyle({ backgroundColor: color})
                              }, null, 4))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: "btn",
                              onClick: ($event: any) => (_unref(applyPresetThemeToSingleSlide)(item))
                            }, "应用", 8, _hoisted_13),
                            _createElementVNode("div", {
                              class: "btn",
                              onClick: ($event: any) => (_unref(applyPresetThemeToAllSlides)(item))
                            }, "应用全局", 8, _hoisted_14)
                          ])
                        ])
                      ], 4))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(Tooltip), {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "主题"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(AppStore)),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text showOrHideSpan" }, "主题", -1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "导出"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(setDialogForExport)('pptx')))
              }, [
                _createVNode(_unref(Export)),
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text showOrHideSpan" }, "导出", -1))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!isHorizontal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(HorizontalItem)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Modal), {
      visible: latexEditorVisible.value,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((latexEditorVisible).value = $event)),
      footer: null,
      centered: "",
      width: 880,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LaTeXEditor, {
          onClose: _cache[19] || (_cache[19] = ($event: any) => (latexEditorVisible.value = false)),
          onUpdate: _cache[20] || (_cache[20] = 
          (data) => {
            _unref(createLatexElement)(data);
            latexEditorVisible.value = false;
          }
        )
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})